import { createNode } from '@glueapp/graph-types';

export const TextLength = createNode({
    id: 'Text Length',
    name: 'Text Length',
    description: 'Gets the length of the text input. For example "Hello" will have length 5 and "Glue is cool" will have length 12',
    aiDescription: 'Returns the character count of a string. Connect a string to "Text"; outputs a number on "Length".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        Length: { kind: 'number' },
    },
    execute: function (input) {
        return { output: { Length: input.inPorts.Text.length } };
    },
});
